import { MessageHandler, Message } from './'
import { Envelope } from 'media/icons'
import { isRouteDisabled } from 'sections/utils'

export default (t, rights) => ({
	id: '14',
	typename: 'Message',
	label: t('message_section.caption'),
	link: isRouteDisabled(rights, '14') ? null : 'meldungen',
	linkDisabled: isRouteDisabled(rights, '14'),
	icon: Envelope,
	subsections: [
		{
			name: t('message_section.sub_sections.show_messages'),
			link: '',
			component: Message
		}
	],
	handler: MessageHandler
})
